import type {Project, ProjectId} from '@package/shared'
import {useProjects} from './useProjects.ts'

export const useProject = (id: ProjectId | null): Project | null => {
  const {projects} = useProjects()
  if (!id) return null
  return projects.find((project) => project.id === id) || null
}
